import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { ChevronUp } from 'lucide-react';
import '../styles/components/back-to-top.css';

const BackToTop = ({ excludedPaths = [] }) => {
  const [isVisible, setIsVisible] = useState(false);
  const location = useLocation();
  const rafRef = useRef(null);
  const halfwayPointRef = useRef(0);

  const updateHalfwayPoint = useCallback(() => {
    const documentHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    halfwayPointRef.current = documentHeight / 2;
  }, []);

  useEffect(() => {
    updateHalfwayPoint();
    window.addEventListener('resize', updateHalfwayPoint, { passive: true });
    return () => window.removeEventListener('resize', updateHalfwayPoint);
  }, [updateHalfwayPoint]);

  useEffect(() => {
    const toggleVisibility = () => {
      if (rafRef.current) return;

      rafRef.current = requestAnimationFrame(() => {
        rafRef.current = null;
        const scrolled = document.documentElement.scrollTop;
        setIsVisible(scrolled > halfwayPointRef.current);
      });
    };

    window.addEventListener('scroll', toggleVisibility, { passive: true });
    toggleVisibility();

    return () => {
      window.removeEventListener('scroll', toggleVisibility);
      if (rafRef.current) {
        cancelAnimationFrame(rafRef.current);
      }
    };
  }, []);

  // Vérifier si le bouton doit être affiché sur cette page
  const shouldShowButton = () => {
    return !excludedPaths.some(path => location.pathname.includes(path));
  };

  // Fonction pour remonter en haut
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  // Ne pas afficher le bouton si on est sur une page exclue
  if (!shouldShowButton()) {
    return null;
  }

  return (
    <button
      className={`back-to-top ${isVisible ? 'visible' : ''}`}
      onClick={scrollToTop}
      aria-label="Retour en haut"
      title="Retour en haut"
    >
      <ChevronUp size={24} />
    </button>
  );
};

export default BackToTop;
